import { Form, Input, Select,message } from "antd";
import { MIN_VALUE,PERCENT_MAX_VALUE,InputTypes, RESTRICTED_SYMBOLS, selectStyleReport } from "../../../../constants/Constants";

export const QuestionsGenerator = (
  text,
  inputFields,
  questionId,
  handleInputChange,
  pillarId,
  ReportForm,
  type='QUESTION'
) => {
  const minValue = MIN_VALUE;
  const maxValue= PERCENT_MAX_VALUE;

  message.config({
    maxCount: 1
  });

  const initializeInputValues = () => {
    inputFields.forEach((field) => {
      const currentValue = ReportForm?.[pillarId]?.[questionId]?.inputFields?.[field.inputId];

      if (currentValue === undefined) {
        handleInputChange(
          pillarId,
          questionId,
          field.inputId,
          null,
          type
        );
      }
    });
  };
  initializeInputValues();

  const textParts = text.split(/(<[^>]+>)/g).map((part, index) => {
    const matchedField = inputFields.find(
      (field) => `<${field.inputId}>` === part
    );

    if (matchedField) {
      const { inputId, inputType, options } = matchedField;
      const key = `${questionId}-${inputId}-${index}`;
      const value =
        ReportForm?.[pillarId]?.[questionId]?.inputFields?.[inputId] ?? null;

      if (inputType === InputTypes.NUMBER) {
        return (
          <Form.Item
            rules={[
              { required: true, message: "This field is required" },
              {
                validator: (_, value) => {
                  // Only validate if the field has a value (allows empty for backspace)
                  if (value === "" || value === null) {
                    return Promise.resolve();
                  }
                  
                  const numericValue = Number(value);
                  if (numericValue > 0) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Value must be greater than 0")
                  );
                },
              },
            ]}
         
         >
            <Input
              key={key}
              type="number"
              value={value}
              inputMode="numeric"
              min={minValue}
              max={maxValue}
              style={{
                transition: "none",
              }}
              className="w-[75px] text-center border-0 border-b-[1px] rounded-none border-dashed border-[#1F405A] focus:ring-0 focus:outline-none mt-4 align-middle"
              onChange={(e) => {
                const inputValue = e.target.value;
                
                // Allow empty value for backspace operations
                if (inputValue === "") {
                  handleInputChange(
                    pillarId,
                    questionId,
                    inputId,
                    inputValue,
                    type
                  );
                  return;
                }
                
                const numericValue = Number(inputValue);
                
                // Only show warning messages for completed inputs, not during editing
                if (numericValue > maxValue) {
                  message.warning("Value should be less than 100.");
                  return;
                }
                
                // Don't immediately validate min value during typing
                // This allows backspacing and intermediate editing states
                handleInputChange(
                  pillarId,
                  questionId,
                  inputId,
                  inputValue,
                  type
                );
              }}
              onKeyDown={(e) => {
                // Only restrict specific symbols, allow backspace and delete
                if (RESTRICTED_SYMBOLS.includes(e.key) && 
                    e.key !== 'Backspace' && 
                    e.key !== 'Delete') {
                  e.preventDefault();
                }
              }}
              onBlur={(e) => {
                // Validate min value on blur (when user finishes editing)
                const inputValue = e.target.value;
                if (inputValue === "" || inputValue === null) {
                  // Handle empty value on blur if needed
                  return;
                }
                
                const numericValue = Number(inputValue);
                if (numericValue < minValue) {
                  message.warning("Value should be greater than 0");
                  handleInputChange(
                    pillarId,
                    questionId,
                    inputId,
                    minValue.toString(),
                    type
                  );
                }
              }}
            />
          </Form.Item>
        );
      } else if (inputType === InputTypes.TEXT) {
        return (
          <Form.Item
            rules={[
              { required: true, message: "This field is required" },
              { max: 500, message: "Text cannot exceed 500 characters" }
            ]}

>
            <Input
              key={key}
              type="text"
              value={value}
              maxLength={500}
              style={{
                transition: "none",
              }}
              className="min-w-[175px] w-auto text-center rounded-none border-0 border-dashed border-b-[1px] border-[#1F405A] focus:ring-0 focus:outline-none mt-4 align-middle"
              onChange={(e) => {
                const inputValue = e.target.value;
                handleInputChange(
                  pillarId,
                  questionId,
                  inputId,
                  inputValue,
                  type
              
                  );
             
                }}
          
            />
          </Form.Item>
        );
      } else if (inputType === InputTypes.DROPDOWN) {
        return (
          <Form.Item
            rules={[{ required: true, message: "Please select an option" }]}
          >
            <Select
              value={value || ""}
              key={key}
              style={selectStyleReport}
              onChange={(selectedValue) =>
                handleInputChange(
                  pillarId,
                  questionId,
                  inputId,
                  selectedValue,
                  type
                )
              }
              options={options.map((option) => ({
                value: option,
                label: option,
              }))}
              showSearch
              filterOption={(input, option) =>
                option?.label.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>
        );
      }
    } else {
      return <span className="inline-block">{part}</span>;
    }
  });

  return <Form className="flex flex-wrap items-center gap-2">{textParts}</Form>;
};